import { OAuthProvider, type OAuthProviderConfig } from "./OAuthProvider";
import type { User } from "../types";

export interface AzureProviderConfig extends Omit<OAuthProviderConfig, "endpoints"> {
  tenantId: string;
}

/** Azure AD / Microsoft Entra ID-flavored OIDC. Endpoints are derived from `tenantId`. */
export class AzureProvider extends OAuthProvider {
  constructor(config: AzureProviderConfig) {
    const root = `https://login.microsoftonline.com/${config.tenantId}/oauth2/v2.0`;
    super({
      ...config,
      endpoints: {
        authorize: `${root}/authorize`,
        token: `${root}/token`,
        userInfo: "https://graph.microsoft.com/oidc/userinfo",
        endSession: `${root}/logout`,
      },
    });
  }

  protected normalizeUser(raw: Record<string, unknown>): User {
    const base = super.normalizeUser(raw);
    return {
      ...base,
      id: String(raw.sub ?? raw.oid ?? base.id),
      email: typeof raw.email === "string" ? raw.email : base.email,
    };
  }
}
